var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitePollyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7013 1.59217C22.9633 3.7779 20.664 7.46791 16.5657 9.83403C12.4675 12.2002 8.12221 12.3464 6.86028 10.1607C5.59835 7.97493 7.89764 4.28493 11.9959 1.9188C16.0941 -0.447319 20.4394 -0.593555 21.7013 1.59217Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56986 14.1124C7.09372 14.1124 9.13972 17.9487 9.13972 22.6809C9.13972 27.4131 7.09372 31.2494 4.56986 31.2494C2.046 31.2494 2.06853e-07 27.4131 0 22.6809C-2.06853e-07 17.9487 2.046 14.1124 4.56986 14.1124Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86852 35.2213C8.13046 33.0355 12.4757 33.1818 16.574 35.5479C20.6722 37.914 22.9715 41.604 21.7096 43.7898C20.4476 45.9755 16.1024 45.8293 12.0041 43.4631C7.90588 41.097 5.60659 37.407 6.86852 35.2213Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2987 43.785C25.0367 41.5993 27.336 37.9093 31.4343 35.5431C35.5325 33.177 39.8778 33.0308 41.1397 35.2165C42.4016 37.4022 40.1024 41.0922 36.0041 43.4584C31.9059 45.8245 27.5606 45.9707 26.2987 43.785Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4301 31.2399C40.9063 31.2399 38.8603 27.4036 38.8603 22.6714C38.8603 17.9391 40.9063 14.1029 43.4301 14.1029C45.954 14.1029 48 17.9391 48 22.6714C48 27.4036 45.954 31.2399 43.4301 31.2399Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1315 10.1167C39.8695 12.3024 35.5243 12.1562 31.426 9.79009C27.3278 7.42397 25.0285 3.73396 26.2904 1.54823C27.5524 -0.637496 31.8976 -0.49126 35.9959 1.87486C40.0941 4.24098 42.3934 7.93099 41.1315 10.1167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePollyIcon);
export default __webpack_public_path__ + "static/media/whitePollyIcon.13d0e96d8023ef54d6cf556ae964ad60.svg";
export { ForwardRef as ReactComponent };